import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "../../../../../../base/multimedia/image/index.js";
import { ImageResize } from "../../../utils/constants.js";
import * as S from "./styled.js";
const FlightContent = ({ label , item  })=>/*#__PURE__*/ _jsxs(S.Wrapper, {
        "data-testid": "FlightContent",
        children: [
            /*#__PURE__*/ _jsxs(S.Row, {
                children: [
                    /*#__PURE__*/ _jsxs(S.Label, {
                        children: [
                            label,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(S.DateLabel, {
                        children: [
                            item?.date,
                            ","
                        ]
                    }),
                    !!item?.company && /*#__PURE__*/ _jsxs(S.Company, {
                        children: [
                            " ",
                            item?.company
                        ]
                    }),
                    !!item?.logoSrc && /*#__PURE__*/ _jsx(Image, {
                        ...ImageResize.COMPANY_NEWCARD,
                        src: item?.logoSrc,
                        title: item?.logoTitle,
                        alt: item?.logoAlt,
                        alternative: item?.logoAlternative
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(S.Airport, {
                children: item?.airport
            })
        ]
    });
export default FlightContent;

//# sourceMappingURL=index.js.map